module.exports = __webpack_public_path__ + "static/media/ar5.dd969ef9.jpg";